import { render } from "./CampaignsManagementEdit.vue?vue&type=template&id=23e249b6"
import script from "./CampaignsManagementEdit.vue?vue&type=script&lang=js"
export * from "./CampaignsManagementEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__